module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "7w8hvile",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
